module.exports = __webpack_public_path__ + "static/media/icon_10.f3e74c7e.png";